import { render, staticRenderFns } from "./addBox.vue?vue&type=template&id=a37520b2&scoped=true"
import script from "./addBox.vue?vue&type=script&lang=js"
export * from "./addBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37520b2",
  null
  
)

export default component.exports